const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const isTimelinePlaybackShortcut = ({ key, altKey, ctrlKey, metaKey, shiftKey, isComposing }) =>
  (key === " " || key === "Spacebar")
  && !altKey && !ctrlKey && !metaKey && !shiftKey && !isComposing;

export const getTimelineKeyboardTarget = (key, currentSeconds, totalDuration, shiftKey = false) => {
  const current = Number.isFinite(Number(currentSeconds)) ? Number(currentSeconds) : 0;
  const maximum = Math.max(0, Number(totalDuration) || 0);
  const arrowStep = shiftKey ? 5 : 1;
  switch (key) {
    case "ArrowRight":
    case "ArrowUp":
      return clamp(current + arrowStep, 0, maximum);
    case "ArrowLeft":
    case "ArrowDown":
      return clamp(current - arrowStep, 0, maximum);
    case "PageUp":
      return clamp(current + 10, 0, maximum);
    case "PageDown":
      return clamp(current - 10, 0, maximum);
    case "Home":
      return 0;
    case "End":
      return maximum;
    default:
      return null;
  }
};
